import React from 'react';
import AutomotiveFunnelPanel from './panels/AutomotiveFunnelPanel';
import AutomotiveInventoryPanel from './panels/AutomotiveInventoryPanel';
import PropertyPeoplePanel from './panels/PropertyPeoplePanel';
import RestaurantCardFleetPanel from './panels/RestaurantCardFleetPanel';
import GroceryStoresPanel from './panels/GroceryStoresPanel';
import MedicalClinicPanel from './panels/MedicalClinicPanel';
import GoalCapacityPanel from './panels/GoalCapacityPanel';

/**
 * Command Center — Vertical Panels extension point.
 * =========================================================================
 * The shared shell renders <VerticalPanels vertical={...} ctx={...} /> directly
 * BENEATH the Overview KPI row. Each vertical contributes zero or more
 * self-contained panels that fetch their own data via EXISTING APIs — the shell
 * has no per-vertical knowledge.
 *
 * Adding a future vertical panel = add an entry to PANEL_REGISTRY. The shared
 * shell is never edited for it.
 */
export const PANEL_REGISTRY = {
    automotive: [AutomotiveFunnelPanel, AutomotiveInventoryPanel],
    restaurant: [RestaurantCardFleetPanel, GoalCapacityPanel],
    // Phase 1 — the minimal grocery console: stores, fridge cards (claimed /
    // unclaimed with their household), household counts, issue cards.
    grocery: [GroceryStoresPanel],
    // Medical: the clinic console (improvement topics + consult requests) plus
    // the SAME embedded Card Fleet Ops the restaurant Command Center carries —
    // which is why the standalone sidebar entry stays hidden for a clinic.
    medical: [MedicalClinicPanel, RestaurantCardFleetPanel],
    property_management: [PropertyPeoplePanel],
    condo: [PropertyPeoplePanel],
    hotel: [],
    default: [],
};

export function getVerticalPanels(vertical) {
    return PANEL_REGISTRY[vertical] || PANEL_REGISTRY.default || [];
}

export default function VerticalPanels({ vertical, ctx }) {
    const panels = getVerticalPanels(vertical);
    if (!panels.length) return null;
    return (
        <div className="space-y-6" data-testid="cc-vertical-panels">
            {panels.map((Panel, i) => (
                <Panel key={Panel.displayName || Panel.name || i} {...ctx} />
            ))}
        </div>
    );
}
